









import { Vue, Component } from 'vue-property-decorator'
import store from './store'

@Component({
  store
})
export default class App extends Vue {}
